// eslint-disable-next-line import/no-anonymous-default-export
export default '3.11.5/2024-03-26T14:11';
